var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({staticClass:"btn",class:[`btn-${_vm.variant}`, _vm.size && `btn-${_vm.size}`],on:{"click":_vm.handleClick}},'button',_vm.$attrs,false),[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }